<template>
  <div>
    <!-- todo this is a top toolbar but temporary i use the mobilebottompersonalizaiton -->
    <template v-if="getEnableMobileBottomToolbar === true">
      <toolbar-top></toolbar-top>
    </template>

    <toolbar-top-agency></toolbar-top-agency>
    <ToolbarSportsTree
      v-if="!checkIsMobile() && getUseExternalTree === true"
      :gameMode="getLiveMode"
    ></ToolbarSportsTree>
    <v-progress-linear
      indeterminate
      color="primary darken-2"
      v-if="loading"
    ></v-progress-linear>
    <LiveDetail v-if="getEventsLiveDetail.length > 0"></LiveDetail>
    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="
        !checkIsMobile() && !checkIsTablet() && getEventsLiveDetail.length == 0
      "
    >
      <div class="tournament-card-header header-live">
        <div class="">
          <span class="label-live">{{ $t('live') }}</span>
        </div>
        <div
          v-if="getGameConsole === 'default'"
          @click="changeLiveMode('preview')"
        >
          <span class="action-btn" :title="$t('prematchEvents')"
            >{{ $t('prematchEvents') }}
            <v-icon dense>mdi-chevron-right</v-icon></span
          >
        </div>
      </div>
      <div class="sport-live-content">
        <v-slide-group
          show-arrows
          class="pt-2 pb-2"
          active-class="success"
          v-if="getUseExternalTree === false"
        >
          <v-slide-item
            v-for="(item, index) in this.getCountLive"
            :key="$uuid.v1()"
          >
            <v-btn
              small
              class="mx-2"
              depressed
              rounded
              @click="changeLive(item.sport)"
              :class="item.selected ? 'active-sport' : ''"
            >
              <span class="text-sport text-capitalize">{{
                getTitle(item.sport)
              }}</span>
              <!--              <span class="count">{{ item.count }}</span>-->
            </v-btn>
          </v-slide-item>
        </v-slide-group>
        <v-progress-linear
          indeterminate
          color="primary darken-2"
          v-if="this.getLoadingLive"
        ></v-progress-linear>
        <div class="preview" v-if="!this.getLoadingLive">
          <v-card class="tournament-card-preview" elevation="1">
            <div
              class="filter-live-category text-center"
              v-if="getUseExternalTree === false"
            >
              <v-chip
                @click="checkAllFilter()"
                outlined
                class="ml-1 mr-1"
                :input-value="categories_filtered.length == 0"
              >
                <img
                  class="img-flag-filter"
                  :src="categoryPath + '1402297580.svg'"
                  :alt="$t('all')"
                />
                {{ $t('all') }}
              </v-chip>
              <v-slide-group active-class="success" style="width: 95%">
                <v-slide-item
                  v-for="(category, index) in this.all_categories"
                  :key="$uuid.v1()"
                >
                  <v-chip
                    @click="filterCategory(category.id)"
                    filter
                    outlined
                    class="ml-1 mr-1"
                    :input-value="categories_filtered.includes(category.id)"
                    filter-icon="mdi-close-circle-outline"
                  >
                    <img
                      class="img-flag-filter"
                      :src="categoryPath + category.id + '.svg'"
                      :alt="category.name"
                    />
                    {{ category.name }}
                  </v-chip>
                </v-slide-item>
              </v-slide-group>
            </div>
            <div
              class="tournament-single"
              v-for="(object, index) in this.getPreviewLive"
              v-if="
                checkIfEvents(object.events) && isFiltered(object.category.id)
              "
            >
              <div class="header" :class="breadcrumbPrematchType">
                <div class="path" v-if="breadcrumbPrematchType === 'default'">
                  <img
                    :src="categoryPath + object.category.id + '.svg'"
                    :alt="object.category.name"
                  />
                  <span class="category-text" :title="object.category.name">{{
                    object.category.name
                  }}</span>
                  <span
                    class="tournament-text highlight"
                    :title="object.tournament.name"
                  >
                    <v-icon dense x-small>mdi-chevron-right</v-icon>
                    {{ object.tournament.name }}
                  </span>
                </div>
                <div class="path breadcrumb" v-else>
                  <span>
                    <img
                      :src="categoryPath + object.category.id + '.svg'"
                      :alt="object.category.name"
                    />
                    {{ object.category.name }}
                  </span>
                  <div class="separator"></div>
                  <span
                    class="tournament-text highlight"
                    :title="object.tournament.name"
                  >
                    {{ object.tournament.name }}
                  </span>
                </div>
                <template
                  v-if="markets_size < 3 && showOutcomeNameOnButton === false"
                >
                  <div
                    class="markets-void"
                    v-for="z in 3 - markets_size"
                    :key="$uuid.v1()"
                  >
                    <span class="name">&nbsp;</span>
                  </div>
                </template>

                <div
                  class="markets"
                  v-for="(mrkt, idx) in visibleMarkets(object.markets)"
                  :key="$uuid.v1()"
                  v-if="showOutcomeNameOnButton === false"
                >
                  <div
                    class="outcome"
                    v-if="mrkt.outcomes.length == 2 && mrkt.specifiers != ''"
                  ></div>
                  <div
                    class="outcome"
                    :class="[
                      mrkt.outcomes.length == 2 && mrkt.specifiers == ''
                        ? 'outcome-50'
                        : '',
                    ]"
                    v-for="(outcome, j) in mrkt.outcomes"
                    :key="$uuid.v1()"
                  >
                    <span class="name">{{ outcome.name }}</span>
                  </div>
                </div>
                <div class="other-odds"></div>
              </div>
              <div class="matches-list">
                <div
                  class="event"
                  v-for="(event, index) in object.events"
                  :key="$uuid.v1()"
                  :class="[
                    index % 2 == 0 ? 'even' : 'odd',
                    showOutcomeNameOnButton === true
                      ? 'justify-space-between'
                      : '',
                  ]"
                  v-if="event.livescore.Scoreboard.Status == 2"
                >
                  <div
                    class="info-match"
                    @click="
                      getDetailOfEventLive(
                        event.id,
                        event.type,
                        object.sport.id,
                        object.tournament.id ? object.tournament.id : '',
                        event.status
                      )
                    "
                  >
                    <span class="competitors">
                      <span class="home" :title="event.competitors.home.name">
                        {{ event.competitors.home.name }}
                        <template
                          v-if="
                            sportIdsPlayerServer.includes(object.sport.id) &&
                            isServing(event.livescore, 'home')
                          "
                        >
                          <v-badge dot inline left color="#ffec00"></v-badge>
                        </template>
                      </span>
                      <span class="away" :title="event.competitors.away.name">
                        {{ event.competitors.away.name }}
                        <template
                          v-if="
                            sportIdsPlayerServer.includes(object.sport.id) &&
                            isServing(event.livescore, 'away')
                          "
                        >
                          <v-badge dot inline left color="#ffec00"></v-badge>
                        </template>
                      </span>
                    </span>
                    <span class="live-info">
                      <span class="label-live-text">{{ $t('live') }}</span>
                      <span class="current-per">{{
                        getMatchCurrentPeriod(
                          event.livescore.Scoreboard.CurrentPeriod
                        )
                      }}</span>
                      <span
                        v-if="
                          getUserType == 4 ||
                          getCashier ||
                          !getSettings.enableQuickBetOnlyForAgency
                        "
                        class="event-qbet"
                        title="qbet"
                      >
                        {{ event.quickbet }}
                      </span>
                      <!--                        <span class="time" v-if="event.livescore.Scoreboard.Time != '-1'">{{getMatchCurrentTime(event.livescore.Scoreboard.Time)}} <span class="blink_me">'</span></span>-->
                    </span>
                  </div>
                  <div class="info-match-result">
                    <span
                      class="time"
                      v-if="event.livescore.Scoreboard.Time != '-1'"
                    >
                      <v-icon x-small>mdi-timer</v-icon
                      >{{
                        getMatchCurrentTime(event.livescore.Scoreboard.Time)
                      }}
                      <span class="blink_me">'</span>
                    </span>
                    <span class="result">
                      {{
                        getResult(event.livescore.Scoreboard.Results, 'home')
                      }}
                      <span class="blink_me"> : </span>
                      {{
                        getResult(event.livescore.Scoreboard.Results, 'away')
                      }}
                    </span>
                  </div>
                  <template v-if="markets_size < 3">
                    <div
                      class="markets-void"
                      v-for="z in 3 - markets_size"
                      :key="$uuid.v1()"
                    >
                      <div class="odds group-sign" v-for="n in 3"></div>
                    </div>
                  </template>
                  <div
                    class="odds group-sign"
                    v-for="(oddMarket, idz) in visibleOddsMarkets(event.odds)"
                    :key="$uuid.v1()"
                  >
                    <div
                      v-if="
                        oddMarket.odds.length == 2 && oddMarket.specifiers != ''
                      "
                      class="odd"
                    >
                      <span class="specifier">{{ oddMarket.specifiers }}</span>
                    </div>

                    <div
                      v-if="!oddMarket.void"
                      class="odd"
                      v-for="(odd, index) in oddMarket.odds"
                      :key="$uuid.v1()"
                      :class="[
                        oddMarket.odds.length == 2 && oddMarket.specifiers == ''
                          ? 'outcome-50'
                          : '',
                      ]"
                    >
                      <!--                      <v-icon class="arrow-up"-->
                      <!--                              v-if="odd.type_change == 'up' && odd.outcome_odd_value > 0  && odd.active">mdi-arrow-up-->
                      <!--                      </v-icon>-->
                      <!--                      <v-icon class="arrow-down"-->
                      <!--                              v-if="odd.type_change == 'down' && odd.outcome_odd_value > 0  && odd.active">-->
                      <!--                        mdi-arrow-down-->
                      <!--                      </v-icon>-->
                      <div
                        v-if="odd.outcome_odd_value > 0 && odd.active"
                        class="value"
                        :class="[
                          'multi-' + oddMarket.multiplicity_min,
                          odd.type_change != undefined
                            ? 'odd_value_' + odd.type_change
                            : 'odd_value_equal',
                          getOddsSources.includes(odd.unique_id)
                            ? 'odd_selected'
                            : '',
                          showOutcomeNameOnButton === true
                            ? 'justify-space-between'
                            : '',
                        ]"
                        @click="
                          putCart(
                            odd,
                            event,
                            object.sport,
                            object.category,
                            object.tournament
                          )
                        "
                      >
                        <div
                          :class="[
                            odd.type_change != undefined
                              ? odd.type_change
                              : 'equal',
                          ]"
                        ></div>
                        <span
                          class="odd-outcome-name"
                          v-if="showOutcomeNameOnButton === true"
                          >{{ odd.outcome_name }}</span
                        >
                        <span class="odd-value">{{
                          odd.outcome_odd_value | odds_type_filter
                        }}</span>
                      </div>
                      <div
                        v-else
                        class="value"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>

                    <div
                      v-if="oddMarket.void"
                      class="odd"
                      v-for="n in oddMarket.n_outcomes"
                      :key="$uuid.v1()"
                    >
                      <div
                        class="value locked"
                        :class="'multi-' + oddMarket.multiplicity_min"
                      >
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </div>
                  <div class="odds group-sign other-odds">
                    <div class="odd">
                      <div
                        v-if="event.count_odds > 0"
                        class="value"
                        @click="
                          getDetailOfEventLive(
                            event.id,
                            event.type,
                            object.sport.id,
                            object.tournament.id ? object.tournament.id : '',
                            event.status
                          )
                        "
                        v-bind:class="{
                          'detail-opened': getEventsLiveDetailActive.includes(
                            event.id
                          ),
                        }"
                        :class="
                          getOddsType == 'american' ? 'btn-more-american' : ''
                        "
                      >
                        <span v-if="getOddsType == 'decimal'"
                          >+ {{ event.count_odds }}</span
                        >
                        <span v-if="getOddsType == 'american'">{{
                          $t('moreBets')
                        }}</span>
                      </div>
                      <div v-else class="value locked">
                        <v-icon dense>mdi-lock</v-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-card>

    <v-card
      class="tournament-card-preview"
      elevation="1"
      v-if="
        (checkIsMobile() || checkIsTablet()) && getEventsLiveDetail.length == 0
      "
    >
      <template v-if="this.getCountLive.length > 0">
        <div class="tournament-card-header header-live">
          <div class="">
            <span class="label-live">{{ $t('live') }}</span>
          </div>
          <div
            v-if="getGameConsole === 'default'"
            class=""
            @click="changeLiveMode('preview')"
          >
            <span class="action-btn" :title="$t('prematchEvents')"
              >{{ $t('prematchEvents') }}
              <v-icon dense>mdi-chevron-right</v-icon></span
            >
          </div>
        </div>
        <div class="sport-live-content sport-live-content-mobile">
          <v-slide-group
            show-arrows
            class="pt-2 pb-2"
            active-class="success"
            v-if="this.checkIsMobile() || this.checkIsTablet()"
          >
            <v-slide-item
              v-for="(item, index) in this.getCountLive"
              :key="$uuid.v1()"
            >
              <button
                class="sport-carousel-btn"
                @click="changeLive(item.sport)"
                :class="item.selected ? 'active-sport' : ''"
              >
                <v-img
                  :src="sportPath + item.sport.id + '.svg'"
                  lazy-src="@/assets/images/slides/placeholderSlide.png"
                  class="sport-icon"
                  v-bind:class="{ 'img-sport-light': light }"
                >
                </v-img>
                <span class="text-sport text-capitalize">{{
                  getTitle(item.sport)
                }}</span>
              </button>
              <!--              <v-btn small class="mx-2" depressed rounded @click="changeLive(item.sport)"-->
              <!--                     :class="(item.selected) ? 'active-sport':''">-->
              <!--                <span class="text-sport text-capitalize">{{ getTitle(item.sport) }}</span>-->
              <!--&lt;!&ndash;                <span class="count">{{ item.count }}</span>&ndash;&gt;-->
              <!--              </v-btn>-->
            </v-slide-item>
          </v-slide-group>
          <v-progress-linear
            indeterminate
            color="primary darken-2"
            v-if="this.getLoadingLive"
          ></v-progress-linear>
          <div class="preview" v-if="!this.getLoadingLive">
            <v-card class="tournament-card-preview" elevation="1">
              <div class="tournament-card-header">
                <div class="actions"></div>
                <div class="markets-select">
                  <v-select
                    v-model="market_selected"
                    :items="this.markets"
                    outlined
                    item-text="name"
                    item-value="unique_id"
                    dense
                  >
                    <template v-slot:append>
                      <v-icon>mdi-unfold-more-horizontal</v-icon>
                    </template>
                  </v-select>
                </div>
                <!--              <div class="other-odds"></div>-->
              </div>
              <div
                class="tournament-single"
                v-for="(object, index) in this.getPreviewLive"
                v-if="checkIfEvents(object.events)"
              >
                <div class="header">
                  <div class="path">
                    <img
                      :src="categoryPath + object.category.id + '.svg'"
                      :alt="object.category.name"
                    />
                    <!--                  <span class="category-text" :title="object.category.name">{{ object.category.name }}</span>-->
                    <span
                      class="tournament-text highlight"
                      :title="object.tournament.name"
                    >
                      <v-icon dense x-small>mdi-chevron-right</v-icon>
                      {{ object.tournament.name | truncate(28, '..') }}
                    </span>
                  </div>

                  <div
                    class="markets"
                    v-for="(mrkt, idx) in object.markets"
                    :key="$uuid.v1()"
                    v-if="idx == 0 && market_selected == mrkt.id"
                  >
                    <div
                      class="outcome"
                      v-if="mrkt.outcomes.length == 2 && mrkt.specifiers != ''"
                    ></div>
                    <div
                      class="outcome"
                      :class="[
                        mrkt.outcomes.length == 2 && mrkt.specifiers == ''
                          ? 'outcome-50'
                          : '',
                      ]"
                      v-for="(outcome, j) in mrkt.outcomes"
                      :key="$uuid.v1()"
                    >
                      <span class="name">{{ outcome.name }}</span>
                    </div>
                  </div>
                  <!--                <div class="other-odds"></div>-->
                </div>

                <div class="matches-list">
                  <div
                    class="event"
                    v-for="(event, index) in object.events"
                    :key="$uuid.v1()"
                    :class="index % 2 == 0 ? 'even' : 'odd'"
                    v-if="event.livescore.Scoreboard.Status == 2"
                  >
                    <div
                      class="info-match"
                      @click="
                        getDetailOfEventLive(
                          event.id,
                          event.type,
                          object.sport.id,
                          object.tournament.id ? object.tournament.id : '',
                          event.status
                        )
                      "
                    >
                      <span class="competitors">
                        <span class="home" :title="event.competitors.home.name">
                          {{ event.competitors.home.name | truncate(20, '..') }}
                          <template
                            v-if="
                              sportIdsPlayerServer.includes(object.sport.id) &&
                              isServing(event.livescore, 'home')
                            "
                          >
                            <v-badge dot inline left color="#ffec00"></v-badge>
                          </template>
                        </span>
                        <span class="away" :title="event.competitors.away.name">
                          {{ event.competitors.away.name | truncate(20, '..') }}
                          <template
                            v-if="
                              sportIdsPlayerServer.includes(object.sport.id) &&
                              isServing(event.livescore, 'away')
                            "
                          >
                            <v-badge dot inline left color="#ffec00"></v-badge>
                          </template>
                        </span>
                      </span>
                      <span class="live-info">
                        <span class="label-live-text">{{ $t('live') }}</span>
                        <span
                          class="time"
                          v-if="event.livescore.Scoreboard.Time != '-1'"
                        >
                          {{
                            getMatchCurrentTime(event.livescore.Scoreboard.Time)
                          }}
                          <span class="blink_me">'</span>
                        </span>
                        <span class="current-per">{{
                          getMatchCurrentPeriod(
                            event.livescore.Scoreboard.CurrentPeriod
                          )
                        }}</span>
                      </span>
                    </div>

                    <div class="info-match-result">
                      <span class="result">
                        {{
                          getResult(event.livescore.Scoreboard.Results, 'home')
                        }}
                        <br />
                        <!--                      <span class="blink_me"> : </span>-->
                        {{
                          getResult(event.livescore.Scoreboard.Results, 'away')
                        }}
                      </span>
                    </div>
                    <div class="odds-box">
                      <div
                        class="odds group-sign"
                        v-for="(oddMarket, idz) in event.odds"
                        :key="$uuid.v1()"
                        v-if="oddMarket.unique_id == market_selected"
                      >
                        <div
                          v-if="
                            oddMarket.odds.length == 2 &&
                            oddMarket.specifiers != ''
                          "
                          class="odd"
                        >
                          <span class="specifier">{{
                            oddMarket.specifiers
                          }}</span>
                        </div>
                        <div
                          v-if="!oddMarket.void"
                          class="odd"
                          v-for="(odd, index) in oddMarket.odds"
                          :key="$uuid.v1()"
                          :class="[
                            oddMarket.odds.length == 2 &&
                            oddMarket.specifiers == ''
                              ? 'outcome-50'
                              : '',
                          ]"
                        >
                          <!--                        <v-icon class="arrow-up"-->
                          <!--                                v-if="odd.type_change == 'up' && odd.outcome_odd_value > 0  && odd.active">mdi-arrow-up-->
                          <!--                        </v-icon>-->
                          <!--                        <v-icon class="arrow-down"-->
                          <!--                                v-if="odd.type_change == 'down' && odd.outcome_odd_value > 0  && odd.active">-->
                          <!--                          mdi-arrow-down-->
                          <!--                        </v-icon>-->
                          <div
                            v-if="odd.outcome_odd_value > 0 && odd.active"
                            class="value"
                            :class="[
                              'multi-' + oddMarket.multiplicity_min,
                              odd.type_change != undefined
                                ? 'odd_value_' + odd.type_change
                                : 'odd_value_equal',
                              getOddsSources.includes(odd.unique_id)
                                ? 'odd_selected'
                                : '',
                            ]"
                            @click="
                              putCart(
                                odd,
                                event,
                                object.sport,
                                object.category,
                                object.tournament
                              )
                            "
                          >
                            <div
                              :class="[
                                odd.type_change != undefined
                                  ? odd.type_change
                                  : 'equal',
                              ]"
                            ></div>
                            {{ odd.outcome_odd_value | odds_type_filter }}
                          </div>
                          <div
                            v-else
                            class="value"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>

                        <div
                          v-if="oddMarket.void"
                          class="odd"
                          v-for="n in oddMarket.n_outcomes"
                          :key="$uuid.v1()"
                        >
                          <div
                            class="value locked"
                            :class="'multi-' + oddMarket.multiplicity_min"
                          >
                            <v-icon dense>mdi-lock</v-icon>
                          </div>
                        </div>
                      </div>
                      <div class="other-odds" v-if="event.count_odds > 0">
                        <div
                          class="label-other-odds"
                          @click="
                            getDetailOfEventLive(
                              event.id,
                              event.type,
                              object.sport.id,
                              object.tournament.id ? object.tournament.id : '',
                              event.status
                            )
                          "
                          v-bind:class="{
                            'detail-opened': getEventsLiveDetailActive.includes(
                              event.id
                            ),
                          }"
                          :class="
                            getOddsType == 'american' ? 'btn-more-american' : ''
                          "
                        >
                          {{ $t('showOther') }}
                          <span v-if="getOddsType == 'decimal'"
                            >+ {{ event.count_odds }}</span
                          >
                          <span v-if="getOddsType == 'american'">{{
                            $t('moreBets')
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>
        </div>
      </template>
      <template v-else-if="this.getLoadingLive === false">
        <div class="d-flex-center-all pt-3 pb-3">
          <v-icon large>mdi-access-point-off</v-icon>
        </div>
        <div class="d-flex-center-all pt-3 pb-3">
          <span class="d-flex-center-all">{{
            $t('noLiveEvents') | capitalize
          }}</span>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import _ from 'lodash'
import LiveDetail from '@/components/center_widgets/LiveDetail'
import { isMobileOnly, isTablet } from 'mobile-device-detect'
import {
  checkIsMobileDevice,
  checkIsTabletDevice,
} from '@/plugins/device-inspector'
import ToolbarTop from '../generic/ToolbarTop'
import ToolbarTopAgency from '../generic/ToolbarTopAgency'
import LoadingSkeleton from '@/components/generic/LoadingSkeleton.vue'

const ToolbarSportsTree = () => ({
  component: import('@/components/center_widgets/ToolbarSportsTree'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'LivePreview',
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    sportIdsPlayerServer: [3467550448],
    limit: 30,
    livesCount: [],
    loading: false,
    categoryPath:
      process.env.VUE_APP_URL_CLOUDFRONT +
      '/svg/categories/rectangular_flags_category/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/sport-images/icons/',
    // sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/light/',
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons/',
    light: window.icons == 'light' ? true : false,
    markets: [],
    market_selected: '',
    markets_size: 0,
    markets_size2: 0,
    all_categories: [],
    categories_filtered: [],
  }),
  components: { ToolbarTopAgency, LiveDetail, ToolbarTop, ToolbarSportsTree },
  computed: {
    ...mapGetters({
      getLanguage: 'settings/getLanguage',
      getFilter: 'tree/getFilter',
      getPreviewLive: 'odds/getPreviewLive',
      getCountLive: 'odds/getCountLive',
      getEventsLiveDetailActive: 'odds/getEventsLiveDetailActive',
      getLoadingPreview: 'odds/getLoadingPreview',
      getLoadingLive: 'odds/getLoadingLive',
      getOddsSources: 'cart/getOddsSources',
      getRulesManager: 'rules/getRulesManager',
      getRulesSkin: 'rules/getRulesSkin',
      getRulesDisabled: 'rules/getRulesDisabled',
      getPlatformId: 'settings/getPlatformId',
      getEventsLiveDetail: 'odds/getEventsLiveDetail',
      getUserType: 'user/getType',
      getCashier: 'user/getCashier',
      getSettings: 'cart/getSettings',
      getOddsType: 'odds/getOddsType',
      getGameConsole: 'settings/getGameConsole',
      getEnableMobileBottomToolbar: 'settings/getEnableMobileBottomToolbar',
      getLiveMode: 'odds/getLiveMode',
      getUseExternalTree: 'uiConfig/useExternalTree',
      getLiveSportSelected: 'odds/getLiveSportSelected',
      maxLiveMarketsInPreview: 'uiConfig/maxLiveMarketsInPreview',
      showMatchDataInRow: 'uiConfig/showMatchDataInRow',
      showOutcomeNameOnButton: 'uiConfig/showOutcomeNameOnButton',
      breadcrumbPrematchType: 'uiConfig/breadcrumbPrematchType',
    }),
  },
  methods: {
    ...mapActions({
      setFilter: 'tree/setFilter',
      removeFromPreview: 'odds/removeFromPreview',
      fetchEventDetail: 'odds/fetchEventDetail',
      fetchEventLiveDetail: 'odds/fetchEventLiveDetail',
      setLoadingPreview: 'odds/setLoadingPreview',
      setLoadingLive: 'odds/setLoadingLive',
      addOddToCart: 'cart/addOddToCart',
      fetchLive: 'odds/fetchLive',
      setLiveMode: 'odds/setLiveMode',
      setLiveSportSelected: 'odds/setLiveSportSelected',
    }),
    sendModeMessageToSkinV2(type, categories) {
      const vm = this
      const message = {
        type: type,
        categories: categories,
      }
      window.parent.postMessage(message, '*')
    },
    checkIsMobile() {
      return checkIsMobileDevice()
    },

    checkIsTablet() {
      return checkIsTabletDevice()
    },
    async changeLive(sport) {
      await this.setLoadingLive({ status: true })
      //await this.setLiveSportSelected({data:{}})
      await this.setLiveSportSelected({
        data: { sport: sport.id, sport_id: sport._id },
      })
      await this.fetchLive({
        sport: sport.id,
        sport_id: sport._id,
        group: true,
      })
      this.getMarkets()
      this.getCategories()
      await this.setLoadingLive({ status: false })
    },
    getTitle(item) {
      return _.find(item.detail, { lang: this.getLanguage }).text
    },
    checkIfEvents(events) {
      const check = false

      if (events != null && events.length > 0) {
        const filtered = _.filter(events, function (o) {
          return o.livescore.Scoreboard.Status == 2
        })
        return filtered.length > 0
      }

      return check
    },

    groupByDate(events) {
      const filtered = _.filter(events, function (o) {
        return o.livescore.Scoreboard.Status == 2
      })
      const refactored = _.groupBy(filtered, 'day')
      return refactored
    },
    increaseLimit() {
      this.limit = this.limit + this.offset
    },
    changeLiveMode(mode) {
      this.setLiveMode({ mode: mode })
    },
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    async putCart(odd, event, sport, category, tournament) {
      if (parseFloat(odd.outcome_odd_value) > 0 && odd.active) {
        await this.addOddToCart({
          odd: odd,
          event: event,
          sport: sport,
          category: category,
          tournament: tournament,
        })
        this.$root.$emit('forceUpdateSingleMultiple')
        this.$root.$emit('forceUpdateIntegral')
        this.$root.$emit('forceUpdateSystem')
      }
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status) {
      this.loading = true
      document.body.scrollIntoView({ behavior: 'smooth' })
      window.parent.postMessage(
        {
          type: 'scrollTop',
        },
        '*'
      )
      await this.fetchEventLiveDetail({
        source: eventSource,
        group: 0,
        sport: sport,
        tournament: tournament,
        status: status,
      })
      this.loading = false
    },
    getMatchCurrentTime(time) {
      if (time >= 0) {
        const minutes = Math.floor(time / 60)
        return minutes
      } else {
        return 0
      }
    },
    getResult(result, team) {
      if (team == 'home') {
        var point = _.find(result, { Position: '1' })
        return point ? +point.Value : 0
      } else if (team == 'away') {
        var point = _.find(result, { Position: '2' })
        return point ? +point.Value : 0
      } else {
        return 0
      }
    },
    getMatchCurrentPeriod(period) {
      let find = _.find(period, { lang: this.getLanguage })
      if (find) {
        return find.text
      } else {
        find = _.find(period, { lang: 'en' })
        if (find) {
          return find.text
        } else {
          return ''
        }
      }
    },
    getMarkets() {
      if (this.getPreviewLive.length > 0 && this.getPreviewLive[0].markets) {
        this.markets = []

        _.forEach(this.getPreviewLive[0].markets, market => {
          market.unique_id =
            market.specifiers != ''
              ? market.id.toString() + '#' + market.specifiers
              : market.id.toString()
          this.markets.push(market)
        })
        this.market_selected = this.markets[0].unique_id
        this.markets_size =
          _.size(this.getPreviewLive[0].markets) > 3
            ? 3
            : _.size(this.getPreviewLive[0].markets)
        this.markets_size2 =
          _.size(this.getPreviewLive[0].markets) > 3
            ? 3
            : _.size(this.getPreviewLive[0].markets)
      }
    },
    getCategories() {
      const check = []
      this.categories_filtered = []
      this.all_categories = []

      _.forEach(this.getPreviewLive, event => {
        if (!check.includes(event.category.id)) {
          this.all_categories.push(event.category)
          check.push(event.category.id)
        }
      })

      if (this.getUseExternalTree === true) {
        const sport = this.getCountLive.filter(
          sport => sport.selected === true
        )[0]
        sport.categories = check
        this.sendModeMessageToSkinV2('sendCategoriesLivePreview', sport)
      }
    },
    isServing(data, mode) {
      const serveNumber = _.find(data.LivescoreExtraData, { Name: 'Turn' })
      if (serveNumber) {
        if (mode == 'home' && serveNumber.Value == '1') {
          return true
        } else if (mode == 'away' && serveNumber.Value == '2') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    filterCategory(id) {
      const index = _.indexOf(this.categories_filtered, id)
      if (index >= 0) {
        this.categories_filtered.splice(index, 1)
      } else {
        this.categories_filtered.push(id)
      }
    },

    isFiltered(id) {
      if (this.categories_filtered.length > 0) {
        return this.categories_filtered.includes(id)
      } else {
        return true
      }
    },

    checkAllFilter() {
      if (this.categories_filtered.length == 0) {
        return
      } else {
        this.categories_filtered = []
      }
    },

    async initMarkets() {
      await this.setLoadingLive({ status: true })
      await this.fetchLive({ group: true })
      if (this.getPreviewLive[0] != undefined) {
        this.getMarkets()
        this.getCategories()
      }

      await this.setLoadingLive({ status: false })
    },
    // todo DRY !!!
    visibleMarkets(markets) {
      const limit =
        typeof this.maxLiveMarketsInPreview === 'number' &&
        this.maxLiveMarketsInPreview > 0
          ? this.maxLiveMarketsInPreview
          : 3

      let marketsArray = []

      if (markets) {
        if (Array.isArray(markets)) {
          marketsArray = markets
        } else if (typeof markets === 'object') {
          marketsArray = Object.values(markets)
        } else {
          console.warn('visibleMarkets: markets not array/not object', markets)
        }
      } else {
        console.warn('visibleMarkets: markets not present', markets)
      }
      return marketsArray.slice(0, limit)
    },
    // todo DRY !!!
    visibleOddsMarkets(odds) {
      const limit =
        typeof this.maxLiveMarketsInPreview === 'number' &&
        this.maxLiveMarketsInPreview > 0
          ? this.maxLiveMarketsInPreview
          : 3

      let marketsArray = []

      if (odds) {
        if (Array.isArray(odds)) {
          marketsArray = odds
        } else if (typeof odds === 'object') {
          marketsArray = Object.values(odds)
        } else {
          console.warn('visibleOddsMarkets: odds format not good', odds)
        }
      } else {
        console.warn('visibleOddsMarkets: odds miss', odds)
      }

      return marketsArray.slice(0, limit)
    },
  },
  async beforeDestroy() {
    this.$root.$off('filter_live_preview_category')
  },
  async mounted() {
    console.log('[DEBUG] LivePreview.vue 13/05/2025 time 19:32')
    const vm = this

    this.$root.$on('forceUpdateLivePreview', () => {
      this.initMarkets()
    })

    if (this.getUseExternalTree === true) {
      this.$root.$on('filter_live_preview_category', function (category) {
        if (category === 1402297580) {
          vm.checkAllFilter()
        } else {
          vm.filterCategory(category)
        }
      })

      this.$root.$on('changeLiveSport', sport => {
        this.changeLive(sport)
      })
    }
    await this.initMarkets()

    // const vm = this;
    // const payload = "[\n" +
    //         "  \"ODDS_CHANGE_LIVE\",\n" +
    //         "  [\n" +
    //         "    {\n" +
    //         "      \"id\": 7972376439,\n" +
    //         "      \"odds\": {\n" +
    //         "        \"set\": [\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"39430818712791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"5.21\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;4629323575;8012078066\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"136783052312791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"4.82\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9700777979#0.5;9551556199\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"152739652212791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"3.57\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.134Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;1850262157#3.5;2599706406\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"55174679212791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"8.94\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;7836838694;4257075511\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"178239008612791691\",\n" +
    //         "              \"status\": 2,\n" +
    //         "              \"odds\": \"1\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9930027521#5.25;730073265\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"112143606512791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"2.54\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.142Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;1275004249;9942056715\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"184477793012791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"2.43\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.142Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;1417858204#3.5;9280968258\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"98704065912791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"3.77\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241#2.5;6725390121\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"199335448612791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"5.04\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.134Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241#1.5;1895685884\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"196813018212791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.41\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241#4.75;730073265\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"184477795512791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.44\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.142Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241#4.5;9280968258\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"138125580812791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.99\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241#1.5;9551556199\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"152739655512791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.75\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.134Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9545715241;2599706406\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"156067401212791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"4.39\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9930027521#2.75;730073265\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"123571007612791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.46\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.142Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;1417858204#3.5;2116679447\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"108550552112791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.24\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9700777979#2.5;9551556199\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"148731692312791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.7\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9930027521#3.75;1371751262\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"201542793912791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"2.78\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.142Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;1417858204#4.5;2116679447\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"98704062612791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.82\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.133Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9700777979#1.5;6725390121\"\n" +
    //         "          },\n" +
    //         "          {\n" +
    //         "            \"_attributes\": {\n" +
    //         "              \"external_id\": \"120861529512791691\",\n" +
    //         "              \"status\": 1,\n" +
    //         "              \"odds\": \"1.68\",\n" +
    //         "              \"lastUpdate\": \"2024-05-02T08:48:05.135Z\"\n" +
    //         "            },\n" +
    //         "            \"unique_id\": \"7972376439;9930027521#4.25;730073265\"\n" +
    //         "          }\n" +
    //         "        ]\n" +
    //         "      }\n" +
    //         "    }\n" +
    //         "  ]\n" +
    //         "]";

    // setInterval(() => {
    //
    //   vm.updateOddsLive(payload);
    // }, 5000);
  },

  async created() {},
}
</script>
<style>
.img-sport-light {
  filter: invert(1);
}

.img-sport-dark {
  filter: invert(0);
}

.filter-live-category {
  display: flex;
  padding-bottom: 5px !important;
  padding-top: 5px !important;
}

.img-flag-filter {
  width: 20px;
  margin-right: 5px !important;
}

.sport-live-content .count {
  background: red;
  padding: 2px 4px;
  border-radius: 3px;
  position: absolute;
  right: -20px;
  top: -8px;
  font-size: 10px;
  color: #fff !important;
}

.filter-live-category i {
  color: var(--active-color) !important;
}
</style>
